import React, { Fragment } from "react";

import {
  Badge,
  DropdownToggle,
  DropdownMenu,
  Button,
  UncontrolledButtonDropdown,
} from "reactstrap";

import { faSignOutAlt, faChevronDown } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { endAuthSession } from "../../../services/authSession";
import { tenantApi } from "../../../services/tenantApi";

const handleCikis = () => {
  endAuthSession("logout");
};

const getInitials = (name) =>
  name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

const formatTarih = (value) => value
  ? new Date(value).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" })
  : "-";

const durumBilgisi = (durum, kalanGun) => {
  if (durum === "Aktif") return { color: "success", label: "Aktif" };
  if (durum === "Yaklasiyor") return { color: "warning", label: kalanGun != null ? `${kalanGun} gün` : "Yaklaşıyor" };
  if (durum === "Bitti") return { color: "danger", label: "Bitti" };
  return { color: "secondary", label: "Paket yok" };
};

class UserBox extends React.Component {
  state = {
    subeAbonelikleri: [],
    subeAbonelikleriYukleniyor: false,
  };

  componentDidMount() {
    this.subeAbonelikleriniYukle();
  }

  subeAbonelikleriniYukle = async () => {
    const kullanici = this.getKullanici();
    const rol = kullanici?.rol;
    const cokluSube = rol === "MultiTenantAdmin" || rol === "MultiTenantUser";
    if (!cokluSube) return;

    try {
      this.setState({ subeAbonelikleriYukleniyor: true });
      const data = await tenantApi.subeAbonelikleriGetir();
      this.setState({ subeAbonelikleri: Array.isArray(data) ? data : [] });
    } catch {
      this.setState({ subeAbonelikleri: [] });
    } finally {
      this.setState({ subeAbonelikleriYukleniyor: false });
    }
  };

  getKullanici = () => {
    try { return JSON.parse(localStorage.getItem("pl_kullanici") || "{}"); }
    catch { return {}; }
  };

  renderSubeAbonelikleri(cokluSube) {
    if (!cokluSube) return null;

    const { subeAbonelikleri, subeAbonelikleriYukleniyor } = this.state;
    const aktifSayisi = subeAbonelikleri.filter((s) => s.durum === "Aktif" || s.durum === "Yaklasiyor").length;
    const bitenSayisi = subeAbonelikleri.filter((s) => s.durum === "Bitti").length;
    const paketYokSayisi = subeAbonelikleri.filter((s) => s.durum === "PaketYok").length;

    return (
      <div style={{ padding: "12px 16px", background: "#0a1528", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <div style={{ color: "#d6e3f3", fontWeight: 700, fontSize: 13, marginBottom: 8 }}>
          Şube abonelikleri
        </div>
        <div style={{ color: "rgba(255,255,255,0.72)", fontSize: 12, marginBottom: 10 }}>
          {subeAbonelikleriYukleniyor
            ? "Yükleniyor..."
            : `${aktifSayisi} aktif / ${bitenSayisi} bitmiş${paketYokSayisi ? ` / ${paketYokSayisi} paket yok` : ""}`}
        </div>

        {!subeAbonelikleriYukleniyor && (
          <div style={{ maxHeight: 190, overflowY: "auto", paddingRight: 4 }}>
            {subeAbonelikleri.length === 0 ? (
              <div style={{ color: "rgba(255,255,255,0.62)", fontSize: 12 }}>Şube aboneliği bulunamadı.</div>
            ) : subeAbonelikleri.map((sube) => {
              const durum = durumBilgisi(sube.durum, sube.kalanGun);
              return (
                <div
                  key={sube.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr auto",
                    gap: 8,
                    alignItems: "center",
                    padding: "8px 0",
                    borderTop: "1px solid rgba(255,255,255,0.07)",
                  }}
                >
                  <div style={{ minWidth: 0 }}>
                    <div style={{ color: "#fff", fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {sube.ad}
                    </div>
                    <div style={{ color: "rgba(255,255,255,0.62)", fontSize: 11, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {sube.sonPaketAdi || "Paket yok"} · Bitiş: {formatTarih(sube.abonelikBitisTarihi)}
                    </div>
                  </div>
                  <Badge color={durum.color} pill style={{ fontSize: 10 }}>
                    {durum.label}
                  </Badge>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  render() {
    const kullanici = this.getKullanici();
    const tamAd = [kullanici.ad, kullanici.soyad].filter(Boolean).join(" ") || "Kullanıcı";
    const email = kullanici.email || "";
    const tenantAd = kullanici.tenantAd || "Tenant";
    const initials = getInitials(tamAd);
    const rol = kullanici.rol;
    const cokluSube = rol === "MultiTenantAdmin" || rol === "MultiTenantUser";
    const displayText = `${cokluSube ? "Çoklu Şube" : tenantAd} / ${tamAd}`;
    const paketBitis = kullanici.abonelikBitisTarihi ? formatTarih(kullanici.abonelikBitisTarihi) : null;

    return (
      <Fragment>
        <div className="header-btn-lg pe-0">
          <div className="widget-content p-0">
            <div className="widget-content-wrapper">
              <div className="widget-content-left">
                <UncontrolledButtonDropdown>
                  <DropdownToggle color="link" className="p-0 d-flex align-items-center" style={{ textDecoration: "none" }}>
                    <span style={{
                      fontSize: 13,
                      fontWeight: 500,
                      color: "#d6e3f3",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "200px",
                    }}>
                      {displayText}
                    </span>
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      className="ms-2 opacity-8"
                      style={{ fontSize: 11, color: "#b7ef4a" }}
                    />
                  </DropdownToggle>

                  <DropdownMenu end className="rm-pointers" style={{
                    minWidth: cokluSube ? 340 : 260,
                    borderRadius: 14,
                    boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
                    border: "none",
                    overflow: "hidden",
                    padding: 0,
                    marginTop: 8,
                  }}>
                    <div style={{
                      background: "linear-gradient(135deg, #0d1f37 0%, #8acb2a 100%)",
                      padding: "24px 20px 20px",
                      textAlign: "center",
                    }}>
                      <div style={{
                        width: 60,
                        height: 60,
                        borderRadius: "50%",
                        background: "rgba(255,255,255,0.18)",
                        border: "2px solid rgba(255,255,255,0.45)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 12px",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: 24,
                      }}>
                        {initials}
                      </div>
                      <div style={{
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: 15,
                        lineHeight: 1.3,
                        letterSpacing: 0.2,
                      }}>
                        {tamAd}
                      </div>
                      {email && (
                        <div style={{
                          color: "rgba(255,255,255,0.72)",
                          fontSize: 12,
                          marginTop: 4,
                          wordBreak: "break-all",
                        }}>
                          {email}
                        </div>
                      )}
                      {!cokluSube && paketBitis && (
                        <div style={{
                          color: "rgba(255,255,255,0.86)",
                          fontSize: 12,
                          marginTop: 8,
                          fontWeight: 600,
                        }}>
                          Paket bitişi: {paketBitis}
                        </div>
                      )}
                    </div>

                    {this.renderSubeAbonelikleri(cokluSube)}

                    <div style={{ padding: "14px 16px", background: "#0a1528" }}>
                      <Button
                        block
                        color="success"
                        outline
                        size="sm"
                        onClick={handleCikis}
                        style={{
                          borderRadius: 8,
                          fontWeight: 600,
                          fontSize: 13,
                          padding: "8px 0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 7,
                          transition: "all 0.2s",
                        }}
                      >
                        <FontAwesomeIcon icon={faSignOutAlt} />
                        Çıkış Yap
                      </Button>
                    </div>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </div>
              <div className="widget-content-left ms-3 header-user-info" style={{ display: "none" }}>
                <div className="widget-heading">{tamAd}</div>
                <div className="widget-subheading">{email}</div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default UserBox;